module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("找工作担心违规收费、拖欠工资？您来举报，经济损失58赔偿，再也不担心上当受骗。财产安全有保障，让您安心找工作！")])]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("如何举报："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("点击职位详情页“举报”按钮，举报信息核实有效后即可获得您所损失的全额赔偿")])]), _vm._v(" "), _c('div', {
    staticClass: "ccaq-bg"
  }, [_c('img', {
    staticClass: "ccaq-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-ccaq.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "applyCompensate": function($event) {
        return _vm.applyCompensate()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("财产安全险")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in"
  }, [_vm._v("找工作担心违规收费、拖欠工资？您来举报，经济损失58赔偿，再也不担心上当受骗。财产安全有保障，让您安心找工作！")])]), _vm._v(" "), _c('div', {
    staticClass: "ccaq-bg"
  }, [_c('img', {
    staticClass: "ccaq-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-ccaq.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401edb33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/CcaqDialog.vue
// module id = fzEA
// module chunks = 1